import styles from './EdlpPricingSplash.module.scss';

/** Swedish accessible name for everyday low price (shared by price a11y builders). */
export const EDLP_A11Y_LABEL = 'Lågt pris varje dag';

/** CDS sizing steps used for the EDLP pricing splash. */
export type EdlpPricingSplashSize = 'sm' | 'lg' | 'xlg' | '2xlg' | '3xlg' | '4xlg';

const sizeClassName: Record<EdlpPricingSplashSize, string> = {
    sm: styles.SizeSm,
    lg: styles.SizeLg,
    xlg: styles.SizeXlg,
    '2xlg': styles.Size2xlg,
    '3xlg': styles.Size3xlg,
    '4xlg': styles.Size4xlg,
};

export const getEdlpPricingSplashSizeClassName = (size: EdlpPricingSplashSize): string =>
    sizeClassName[size];

/** Prefix price a11y with the EDLP claim (parent-owned name pattern). */
export const getEdlpPrimaryPriceA11yText = (priceA11y: string | undefined) =>
    [EDLP_A11Y_LABEL, priceA11y].filter(Boolean).join(', ');
